/* eslint-disable import/no-unresolved */
import { Reducer } from "redux";
import { bindLoanDetailsAPIData } from "src/helpers/FormDetails";
import { initialValues } from "src/helpers/FormDetails/LoanDetails";
import { SAVE_LOAN_DETAILS, SET_LOAN_DETAILS } from "src/redux/Types/loanDetails";
import { ILoanDetails } from "./interface";

const initialState: ILoanDetails = {
  ...initialValues,
  applicationId: ""
};

// eslint-disable-next-line default-param-last
const loanDetailsReducer: Reducer<ILoanDetails> = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_LOAN_DETAILS: {
      const data = bindLoanDetailsAPIData(state, action.payload.apiData, action.payload.masterData);
      return { ...state, ...data, applicationId: action.payload.leadId };
    }
    case SET_LOAN_DETAILS: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};

export default loanDetailsReducer;
